module.exports = __webpack_public_path__ + "img/nt55-01-80-1.prt.f872e282.jpg";